module.exports = __webpack_public_path__ + "static/media/stop.9974121f.svg";